import { IProductStockStatus } from "../../types";
export const getStockStatusesResponseMock = () => ({
    products: {
        items: [
            {
                sku: "sticks-carton-burgundy",
                __typename: "BundleProduct",
                stock_status: IProductStockStatus.OutOfStock,
                items: [
                    {
                        option_id: 4647,
                        title: "packs",
                        __typename: "BundleItem",
                        sku: "sticks-carton-burgundy",
                        all_options: [
                            {
                                id: 4732,
                                label: "Camel Burgundy - pack",
                                product: {
                                    id: 13608,
                                    name: "Camel Burgundy - pack",
                                    sku: "sticks-pack-burgundy",
                                    stock_status: IProductStockStatus.OutOfStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                        ],
                    },
                ],
            },
            {
                sku: "sticks-carton-tan",
                __typename: "BundleProduct",
                stock_status: IProductStockStatus.InStock,
                items: [
                    {
                        option_id: 4646,
                        title: "packs",
                        __typename: "BundleItem",
                        sku: "sticks-carton-tan",
                        all_options: [
                            {
                                id: 4730,
                                label: "Camel Tan - pack",
                                product: {
                                    id: 13606,
                                    name: "Camel Tan - pack",
                                    sku: "sticks-pack-tan",
                                    stock_status: IProductStockStatus.InStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                        ],
                    },
                ],
            },
            {
                sku: "sticks-carton-amber",
                __typename: "BundleProduct",
                stock_status: IProductStockStatus.InStock,
                items: [
                    {
                        option_id: 4645,
                        title: "packs",
                        __typename: "BundleItem",
                        sku: "sticks-carton-amber",
                        all_options: [
                            {
                                id: 4728,
                                label: "Camel Amber - pack",
                                product: {
                                    id: 13604,
                                    name: "Camel Amber - pack",
                                    sku: "sticks-pack-amber",
                                    stock_status: IProductStockStatus.InStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                        ],
                    },
                ],
            },
            {
                sku: "sticks-carton-silver",
                __typename: "BundleProduct",
                stock_status: IProductStockStatus.InStock,
                items: [
                    {
                        option_id: 4644,
                        title: "packs",
                        __typename: "BundleItem",
                        sku: "sticks-carton-silver",
                        all_options: [
                            {
                                id: 4726,
                                label: "Camel Silver - pack",
                                product: {
                                    id: 13601,
                                    name: "Camel Silver - pack",
                                    sku: "sticks-pack-silver",
                                    stock_status: IProductStockStatus.InStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                        ],
                    },
                ],
            },
            {
                sku: "sticks-carton-gold",
                __typename: "BundleProduct",
                stock_status: IProductStockStatus.InStock,
                items: [
                    {
                        option_id: 4643,
                        title: "packs",
                        __typename: "BundleItem",
                        sku: "sticks-carton-gold",
                        all_options: [
                            {
                                id: 4724,
                                label: "Camel Gold - pack",
                                product: {
                                    id: 13600,
                                    name: "Camel Gold - pack",
                                    sku: "sticks-pack-gold",
                                    stock_status: IProductStockStatus.InStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                        ],
                    },
                ],
            },
            {
                sku: "sticks-carton-bronze",
                __typename: "BundleProduct",
                stock_status: IProductStockStatus.InStock,
                items: [
                    {
                        option_id: 4642,
                        title: "packs",
                        __typename: "BundleItem",
                        sku: "sticks-carton-bronze",
                        all_options: [
                            {
                                id: 4722,
                                label: "Camel Bronze - pack",
                                product: {
                                    id: 13598,
                                    name: "Camel Bronze - pack",
                                    sku: "sticks-pack-bronze",
                                    stock_status: IProductStockStatus.InStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                        ],
                    },
                ],
            },
            {
                sku: "sticks-mix-n-match-subscription",
                __typename: "BundleProduct",
                stock_status: IProductStockStatus.InStock,
                items: [
                    {
                        option_id: 4655,
                        title: "sticks",
                        __typename: "BundleItem",
                        sku: "sticks-mix-n-match-subscription",
                        all_options: [
                            {
                                id: 4746,
                                label: "Camel Gold - Pack",
                                product: {
                                    id: 13600,
                                    name: "Camel Gold - Pack",
                                    sku: "sticks-pack-gold",
                                    stock_status: IProductStockStatus.InStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                            {
                                id: 4747,
                                label: "Camel Silver - Pack",
                                product: {
                                    id: 13601,
                                    name: "Camel Silver - Pack",
                                    sku: "sticks-pack-silver",
                                    stock_status: IProductStockStatus.OutOfStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                            {
                                id: 4748,
                                label: "Camel Amber - Pack",
                                product: {
                                    id: 13604,
                                    name: "Camel Amber - Pack",
                                    sku: "sticks-pack-amber",
                                    stock_status: IProductStockStatus.OutOfStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                            {
                                id: 4749,
                                label: "Camel Tan - Pack",
                                product: {
                                    id: 13606,
                                    name: "Camel Tan - Pack",
                                    sku: "sticks-pack-tan",
                                    stock_status: IProductStockStatus.OutOfStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                            {
                                id: 4750,
                                label: "Camel Burgundy - Pack",
                                product: {
                                    id: 13608,
                                    name: "Camel Burgundy - Pack",
                                    sku: "sticks-pack-burgundy",
                                    stock_status: IProductStockStatus.InStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                        ],
                    },
                ],
            },
            {
                sku: "sticks-mix-n-match-subscription",
                __typename: "BundleProduct",
                stock_status: IProductStockStatus.InStock,
                items: [
                    {
                        option_id: 4655,
                        title: "sticks",
                        __typename: "BundleItem",
                        sku: "sticks-mix-n-match",
                        all_options: [
                            {
                                id: 4746,
                                label: "Camel Gold - Pack",
                                product: {
                                    id: 13600,
                                    name: "Camel Gold - Pack",
                                    sku: "sticks-pack-gold",
                                    stock_status: IProductStockStatus.InStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                            {
                                id: 4747,
                                label: "Camel Silver - Pack",
                                product: {
                                    id: 13601,
                                    name: "Camel Silver - Pack",
                                    sku: "sticks-pack-silver",
                                    stock_status: IProductStockStatus.OutOfStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                            {
                                id: 4748,
                                label: "Camel Amber - Pack",
                                product: {
                                    id: 13604,
                                    name: "Camel Amber - Pack",
                                    sku: "sticks-pack-amber",
                                    stock_status: IProductStockStatus.OutOfStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                            {
                                id: 4749,
                                label: "Camel Tan - Pack",
                                product: {
                                    id: 13606,
                                    name: "Camel Tan - Pack",
                                    sku: "sticks-pack-tan",
                                    stock_status: IProductStockStatus.OutOfStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                            {
                                id: 4750,
                                label: "Camel Burgundy - Pack",
                                product: {
                                    id: 13608,
                                    name: "Camel Burgundy - Pack",
                                    sku: "sticks-pack-burgundy",
                                    stock_status: IProductStockStatus.InStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                        ],
                    },
                ],
            },
            {
                sku: "consumables-10-sticks-mix-n-match-subscription",
                __typename: "BundleProduct",
                stock_status: IProductStockStatus.InStock,
                items: [
                    {
                        option_id: 4755,
                        title: "packs",
                        __typename: "BundleItem",
                        sku: "consumables-10-sticks-mix-n-match-subscription",
                        all_options: [
                            {
                                id: 4964,
                                label: "Consumables Camel Gold - Pack",
                                product: {
                                    id: 14350,
                                    name: "Consumables Camel Gold - Pack",
                                    sku: "consumables-sticks-pack-gold",
                                    stock_status: IProductStockStatus.InStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                            {
                                id: 4965,
                                label: "Consumables Camel Amber - Pack",
                                product: {
                                    id: 14353,
                                    name: "Consumables Camel Amber - Pack",
                                    sku: "consumables-sticks-pack-amber",
                                    stock_status: IProductStockStatus.InStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                            {
                                id: 4966,
                                label: "Consumables Camel Tan - Pack",
                                product: {
                                    id: 14354,
                                    name: "Consumables Camel Tan - Pack",
                                    sku: "consumables-sticks-pack-tan",
                                    stock_status: IProductStockStatus.InStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                            {
                                id: 4967,
                                label: "Consumables Camel Burgundy - Pack",
                                product: {
                                    id: 14355,
                                    name: "Consumables Camel Burgundy - Pack",
                                    sku: "consumables-sticks-pack-burgundy",
                                    stock_status: IProductStockStatus.InStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                            {
                                id: 4963,
                                label: "Consumables Camel Silver - Pack",
                                product: {
                                    id: 14352,
                                    name: "Consumables Camel Silver - Pack",
                                    sku: "consumables-sticks-pack-silver",
                                    stock_status: IProductStockStatus.InStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                            {
                                id: 4962,
                                label: "Consumables Camel Bronze - Pack",
                                product: {
                                    id: 14351,
                                    name: "Consumables Camel Bronze - Pack",
                                    sku: "consumables-sticks-pack-bronze",
                                    stock_status: IProductStockStatus.OutOfStock,
                                    __typename: "SimpleProduct",
                                },
                            },
                        ],
                    },
                ],
            },
        ],
    },
});
//# sourceMappingURL=getStockStatusesResponse.mock.js.map